var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.774231 10.6758C0.774231 10.0401 0.638017 7.53154 2.61691 5.54129C3.94878 4.20185 5.94205 3.96953 8.3258 3.86359V0.625192C8.3258 0.0828464 8.96919 -0.202163 9.37086 0.162248L14.7949 5.0831C15.0665 5.32945 15.0686 5.75553 14.7996 6.00465L9.37559 11.0279C8.97544 11.3985 8.3258 11.1147 8.3258 10.5693V7.35067C6.81231 7.39229 5.73422 7.48857 4.75472 7.80018C2.86154 8.40247 1.73815 10.9851 1.43521 11.7718C1.38296 11.9075 1.25357 12.0001 1.10819 12.0001C0.921662 12.0001 0.770505 11.849 0.771091 11.6624C0.772171 11.319 0.774231 10.9243 0.774231 10.6758Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.d5b2df3f409f54cf4831e0f8859a8053.svg";
export { ForwardRef as ReactComponent };